import { normalize } from 'utils';
import { css } from 'styled-components';

// TODO: Replace old typography interface with new one (see: https://jira.9y.engineering/browse/COR-272)

enum FontWeight {
  light = 200,
  regular = 400,
  medium = 500,
  semiBold = 600,
  bold = 700,
}

enum FontFamily {
  Montserrat = 'Montserrat',
  Amiri = 'Amiri',
}

const fontFamily = 'Montserrat';

export const font = {
  fontFamily,
  semiBold: css`
    font-family: ${fontFamily};
    font-weight: 600;
  `,
  regular: css`
    font-family: ${fontFamily};
    font-weight: 400;
  `,
  medium: css`
    font-family: ${fontFamily};
    font-weight: 500;
  `,
  title: {
    bold: css`
      font-family: ${FontFamily.Amiri};
      font-weight: ${FontWeight.bold};
    `,
  },
  content: {
    semiBold: css`
      font-family: ${FontFamily.Montserrat};
      font-weight: ${FontWeight.semiBold};
    `,
    regular: css`
      font-family: ${FontFamily.Montserrat};
      font-weight: ${FontWeight.regular};
    `,
    medium: css`
      font-family: ${FontFamily.Montserrat};
      font-weight: ${FontWeight.medium};
    `,
  },
};

export const size = {
  xxs: normalize('8px'),
  xs: normalize('10px'),
  sm: normalize('12px'),
  rg: normalize('14px'),
  md: normalize('16px'),
  ml: normalize('20px'),
  lg: normalize('24px'),
  xl: normalize('34px'),
  xxl: normalize('36px'),
  xxxl: normalize('46px'),
};

export const weight = {
  light: '200',
  medium: '400',
  bold: '700',
  heavy: '800',
};
